document.documentElement.classList.remove('no-js');

/* ---------------- Header scroll transition ---------------- */
(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;
  var lastY = window.scrollY;
  window.addEventListener(
    'scroll',
    function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
      lastY = window.scrollY;
    },
    { passive: true }
  );
})();

/* ---------------- Drawers (cart / search / mobile menu) ---------------- */
(function () {
  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    drawer.setAttribute('data-open', '');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var input = drawer.querySelector('input[type="search"], input[type="text"]');
    if (input) setTimeout(function () { input.focus(); }, 150);
  }

  function closeDrawer(drawer) {
    drawer.removeAttribute('data-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      var drawer = closer.closest('[data-drawer]');
      if (drawer) closeDrawer(drawer);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-drawer][data-open]').forEach(closeDrawer);
    }
  });

  window.CDU = window.CDU || {};
  window.CDU.openDrawer = openDrawer;
})();

/* ---------------- Cart (AJAX API) ---------------- */
(function () {
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshCartDrawer() {
    fetch('/?section_id=cart-drawer-body')
      .catch(function () {})
      .then(function () {});
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function updateCartUI(cart) {
    updateCartCount(cart.item_count);
    var subtotalEls = document.querySelectorAll('[data-cart-subtotal]');
    subtotalEls.forEach(function (el) {
      el.textContent = formatMoney(cart.total_price);
    });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return amount.replace('.', ',');
  }

  function reloadCartSections() {
    window.location.reload();
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('form[action^="/cart/add"], form[data-type="add-to-cart-form"]') || form.closest('.product-form')) {
      if (form.querySelector('[name="checkout"]:focus')) return; // let native buy-now submit
    }

    if (form.action && form.action.indexOf('/cart/add') !== -1) {
      e.preventDefault();
      var formData = new FormData(form);
      var submitter = e.submitter;
      if (submitter && submitter.name === 'checkout') {
        form.submit();
        return;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          return fetchCart();
        })
        .then(function (cart) {
          updateCartUI(cart);
          reloadCartSections();
          window.CDU.openDrawer('cart-drawer');
        })
        .catch(function () {
          form.submit();
        });
    }
  });

  document.addEventListener('click', function (e) {
    var checkoutBtn = e.target.closest('[data-cart-checkout]');
    if (checkoutBtn) {
      window.location.href = '/checkout';
      return;
    }
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      changeLineQuantity(removeBtn.getAttribute('data-key'), 0);
    }
    var inc = e.target.closest('[data-cart-quantity-increase]');
    if (inc) {
      var input = inc.parentElement.querySelector('[data-cart-quantity-input]');
      input.value = parseInt(input.value, 10) + 1;
      changeLineQuantity(inc.getAttribute('data-key'), input.value);
    }
    var dec = e.target.closest('[data-cart-quantity-decrease]');
    if (dec) {
      var input2 = dec.parentElement.querySelector('[data-cart-quantity-input]');
      var newVal = Math.max(0, parseInt(input2.value, 10) - 1);
      input2.value = newVal;
      changeLineQuantity(dec.getAttribute('data-key'), newVal);
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cart-quantity-input]')) {
      changeLineQuantity(e.target.getAttribute('data-key'), e.target.value);
    }
  });

  function changeLineQuantity(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        window.location.reload();
      })
      .catch(function () {});
  }
})();

/* ---------------- Product page: gallery ---------------- */
(function () {
  var thumbs = document.querySelectorAll('.product-gallery__thumb');
  if (!thumbs.length) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mediaId = thumb.getAttribute('data-thumb-for');
      document.querySelectorAll('.product-gallery__slide').forEach(function (slide) {
        slide.hidden = slide.getAttribute('data-media-id') !== mediaId;
      });
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
})();
